/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useRef, useEffect } from "react";
import crypto from "../../Crypto";
import { ModeloPost } from "../../ModeloCrud";
import { useFormik } from "formik";
import { Grid, Container, Box, Divider, Typography } from "@mui/material";
import * as yup from "yup";
import TextField from "@mui/material/TextField";
import CustomModal from "../../modals/CustomModal";
import SaveCancelButtons from "../../SaveCancelButtons";
import "dayjs/locale/en-gb";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateField } from "@mui/x-date-pickers/DateField";
import { toast } from "react-toastify";
import PercentIcon from "@mui/icons-material/Percent";
import { useLiquidaciones } from "../contexts/LiquidacionesContext";
import { useLiquidarUtils } from "../hooks/useLiquidarUtils"; // Ajustá la ruta si es distinta

const validationSchema = yup.object({
  vigencia: yup
    .date()
    .typeError("Fecha inválida")
    .required("Campo Obligatorio."),
  porcentaje: yup
    .number()
    .min(1, "El porcentaje no puede ser menor a 1")
    .max(100, "El porcentaje no puede ser mayor a 100"),
});

export default function ModalAumentarValores({
  showModal,
  hideModal,
  listaRow,
  afterSave,
}) {
  const [myloading, setMyLoading] = React.useState(false);
  const { searchingValoresHonorarios, selectedListaHonorariosRows } =
    useLiquidaciones();
  const { handleBuscarValoresListaHonorarios } = useLiquidarUtils();

  const handleClose = () => {
    // limpia el form antes de cerrar
    formik.resetForm();
    hideModal();
  };
  const formik = useFormik({
    initialValues: {
      vigencia: null,
      porcentaje: null,
    },
    enableReinitialize: true,
    validationSchema,
    onSubmit: (values) => {
      grabar(values);
    },
  });

  async function grabar(values) {
    setMyLoading(true);
    const Data = {
      porcentaje: values.porcentaje ?? 0,
      vigencia: values.vigencia.format("YYYY-MM-DD"),
    };
    console.log("Grabar honorario - Data:", Data);
    let result = await ModeloPost(
      "listas-precios-honorarios",
      listaRow.id,
      "aumentar-valores",
      Data
    );
    setMyLoading(false);
    if (result.error === false) {
      toast.success(result.listado);
      handleClose();
      if (selectedListaHonorariosRows.length > 0) {
        // Si hay filas seleccionadas, actualiza los valores de la lista de honorarios
        handleBuscarValoresListaHonorarios();
      }
    } else {
      let mensajeError = "Error al cargar el honorario.";
      if (
        result.errormessage?.includes("Duplicate entry") ||
        result.errormessage?.includes("23000")
      ) {
        mensajeError += " Probablemente la vigencia ya existe para ese código.";
      } else {
        mensajeError += " " + result.errormessage;
      }

      toast.error(mensajeError);
    }
  }

  return (
    <CustomModal
      open={showModal}
      onClose={handleClose}
      title="Aumentar honorarios"
      disableActions
      maxWidth="sm"
      icon={<PercentIcon fontSize="medium" sx={{ color: "white" }} />}
    >
      <Container maxWidth="sm">
        <form onSubmit={formik.handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom>
                Aumentar honorarios de la lista: {listaRow?.nombre}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <LocalizationProvider
                dateAdapter={AdapterDayjs}
                adapterLocale={"en-gb"}
              >
                <DateField
                  id="vigencia"
                  label="Fecha de Vigencia"
                  value={formik.values.vigencia}
                  inputFormat="DD/MM/YYYY"
                  format="DD/MM/YYYY"
                  //defaultValue={dayjs(row.alta_usa)}
                  onChange={(value) => formik.setFieldValue("vigencia", value)}
                  sx={{
                    marginTop: {
                      xs: 2,
                      md: 2,
                    },
                  }}
                  size="small"
                  helperText={
                    formik.touched.vigencia ? formik.errors.vigencia : ""
                  }
                  error={
                    formik.touched.vigencia && Boolean(formik.errors.vigencia)
                  }
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12}>
              <TextField
                id="porcentaje"
                label="Porcentaje de Aumento"
                value={formik.values.porcentaje}
                type="number"
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                helperText={
                  formik.touched.porcentaje ? formik.errors.porcentaje : ""
                }
                error={
                  formik.touched.porcentaje && Boolean(formik.errors.porcentaje)
                }
                margin="dense"
                variant="outlined"
                size="small"
              />
            </Grid>
          </Grid>
          <Divider sx={{ mt: 3 }} />
          <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end" }}>
            <SaveCancelButtons
              handleCancel={handleClose}
              loading={myloading}
              isModal={true}
            />
          </Box>
        </form>
      </Container>
    </CustomModal>
  );
}
